'use client';

interface StoreQuickFilterProps {
  citySlug: string;
}

export default function StoreQuickFilter(_props: StoreQuickFilterProps) {
  return (
    <div className="bg-transparent w-full">
      <div className="px-4 py-3">
        <h2 className="text-2xl md:text-2xl font-bold text-neutral-90">
          Quanh đây
        </h2>
      </div>
    </div>
  );
}
